import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import {
  GET_DOC_LIST,
  POST_ADD_TRANS_FILE,
  POST_REQUEST_DOC_MULTIPLE,
} from "../APIS";
import {
  ButtonActions,
  doc_type,
  DocStatus,
  MimeFile,
  StatusFile,
} from "./DocUI";
import LoadingBtn from "../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../Library/AlertNotif";
import { Error404 } from "../../../Library/LoaderPage";
import { RSAencryptData } from "./RSAEnc";
import { openModal, PopUpMessage } from "../../../Library/ModalPopUp";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
export function Documents({ student }) {
  const currMail = useMemo(() => AuthDecode.identity?.email || "", []);
  const registered_id = student?.registered_id || "";
  
  const [docList, setDocList] = useState({
    loading: false,
    data: [],
    message: "",
  });

  const OWNER_DOC = async () => {
    setDocList({ loading: true, data: [], message: "" });
    const param = { owner: registered_id };
    const objData = JSON.stringify(param);
    const rsaEnc = RSAencryptData(objData);
    const formData = new FormData();
    formData.append("data", rsaEnc);
    const results = await GET_DOC_LIST(formData);
    if (results.result === "success") {
      if (results.data.data && Object.values(results.data.data).length > 0) {
        const get_active_doc = results.data.data.filter(
          (item) => item.status === "strg.file.status.uploaded" || item.status === "strg.file.status.updated"
        );
        const mergedDocuments = mergeDocuments(doc_type, get_active_doc, registered_id);
        setDocList({
          loading: false,
          data: mergedDocuments,
          message: "",
        });
      } else {
        setDocList({
          loading: false,
          data: doc_type.map(item => {
            return {
              ...item,
              file_id:"",
              mimetype:"",
              reff_id:"",
              verified: "",
              verifiedby: "",
              verify: 0,
              createdby: "",
            }
          }),
          message: "",
        });
      }
    } else {
      setDocList({ loading: false, data: doc_type, message: results.msg });
    }
  };

  useEffect(() => {
    if (registered_id && registered_id !== "") {
      OWNER_DOC();
    }
  }, [registered_id]);


  const [uploadProgress, setUploadProgress] = useState({});
  const [isUpload, setIsUpload] = useState(false);
  const handleFileUpload = async (file, doc_type) => {
    setIsUpload(true);
    setUploadProgress((prevProgress) => ({
      ...prevProgress,
      [file.name]: 0,
    }));

    const param = {
      doc_type: doc_type,
      user: currMail,
      owner: registered_id,
    };
    // console.log(param);

    try {
      const objData = JSON.stringify(param);
      const rsaEnc = RSAencryptData(objData);
      const formData = new FormData();
      formData.append("data", rsaEnc);
      formData.append("file", file);

      setUploadProgress((prevProgress) => ({
        ...prevProgress,
        [file.name]: 20,
      }));

      const result = await POST_REQUEST_DOC_MULTIPLE(formData, (progress) => {
        setUploadProgress((prevProgress) => ({
          ...prevProgress,
          [file.name]: progress - 10,
        }));
      });

      if (result.result === "success") {
        setUploadProgress((prevProgress) => ({
          ...prevProgress,
          [file.name]: 100,
        }));

        const file_id = result.data?.data?.file_id || "";

        //ADD DOC TRANS
        const param_trans = {
          file_id: file_id,
          reff_id: registered_id,
          user: currMail,
        };
        const objData_trans = JSON.stringify(param_trans);
        const rsaEnc_trans = RSAencryptData(objData_trans);
        const formData = new FormData();
        formData.append("data", rsaEnc_trans);
        const result_trans = await POST_ADD_TRANS_FILE(formData);
        if (result_trans.result === "success") {
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: 100,
          }));
          OWNER_DOC(registered_id);
        } else {
          openModal({
            message: (
              <PopUpMessage
                title={"Failed to create doc transaction"}
                message={
                  "Successfully uploaded but failed create doc transaction"
                }
                type={"success"}
              />
            ),
          });
        }
        //END DOC TRANS

        
      } else {
        openModal({
          message: (
            <PopUpMessage
              title={"Failed to upload file"}
              message={
                "This may be due to a weak network connection or a busy server. Please try again shortly"
              }
              type={"error"}
            />
          ),
        });
        setUploadProgress((prevProgress) => ({
          ...prevProgress,
          [file.name]: 0,
        }));
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadProgress((prevProgress) => ({
        ...prevProgress,
        [file.name]: 0,
      }));
    } finally {
      setIsUpload(false);
    }
  };

  return (
    <div className="card card-custom gutter-b example example-compact bg-white">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
            <thead>
              <tr className="text-uppercase bg-light">
                <th>Doc Type</th>
                <th>Status</th>
                <th width="30%">Action</th>
              </tr>
            </thead>
            <tbody>
              {docList.loading ? (
                <tr>
                  <td colSpan={3} className="px-5">
                    <LoadingBtn />
                  </td>
                </tr>
              ) : docList.message ? (
                <tr>
                  <td colSpan={3} className="px-5">
                    <AlertNotif message={docList.message} color="danger" />
                  </td>
                </tr>
              ) : docList.data.length > 0 ? (
                docList.data.map((v, index) => (
                  <tr key={index}>
                    <td>{v.file_id ? <MimeFile data={v} /> : v.name}</td>
                    <td>
                      <StatusFile data={v} />
                    </td>
                    <td>
                      <ButtonActions
                        data={v}
                        onFileUpload={handleFileUpload}
                        uploadProgress={uploadProgress}
                        isUpload={isUpload}
                        ReloadData={() => OWNER_DOC(registered_id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="px-5">
                    <Error404 />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export const mergeDocuments = (docTypes, docList, registered_id) => {
  // Buat map untuk mempercepat pencarian
  const docMap = new Map(docList.map((doc) => [doc?.doc_type, doc]));

  // Gabungkan dan isi nilai default
  return docTypes.map((type) => {
    const doc = docMap.get(type.id) || {};
    return {
      ...type,
      file_id: doc?.file_id || "",
      mimetype: doc?.mimetype || "",
      reff_id: registered_id,
      verified: doc?.verified || null,
      verifiedby: doc?.verifiedby || "",
      verify: doc?.verify || 0,
      createdby: doc?.createdby || "",
      doc_type:doc?.doc_type || "",
      status:doc?.status || "",
      size:doc?.size || 0,
      public_url:doc?.public_url || ""
    };
  });
};
